export class LoadStoriesArchivedAction {
  static readonly type = '[StoriesArchived] Load Stories'

  constructor() { }
};